module.exports = __webpack_public_path__ + "static/media/overdrive_left.c09774f1.png";